module.exports = __webpack_public_path__ + "static/media/intercom.bb369379.png";